import React from "react";
import Environment from "~/common/Environment";

interface Props {
  selectedItemNumber: string;
  groupItemNumber: string;
  groupingItemNumbers: string[];
  setSelectedItemNumber: React.Dispatch<React.SetStateAction<string>>;
}

const InternalNotesVirtualGroupSelect = ({
  selectedItemNumber,
  groupItemNumber,
  groupingItemNumbers,
  setSelectedItemNumber,
}: Props) => {
  return (
    <>
      <div
        style={{
          fontSize: "16px",
          marginBottom: "5px",
          textAlign: "center",
        }}
      >
        <a
          href={`https://adminportal.${
            Environment.domainWithEnvironment
          }/External/Virtual Grouping/Upsert?virtualGroupId=${
            groupItemNumber.split("^")[0]
          }`}
          target="_blank"
          rel="noopener noreferrer"
        >
          Go to Virtual Grouping
        </a>
      </div>
      <h3 style={{ padding: "5px" }}>
        <select
          value={selectedItemNumber}
          onChange={(event) => setSelectedItemNumber(event.target.value)}
          style={{ fontSize: "16px" }}
          data-testid="vg-group-select"
        >
          {groupingItemNumbers.map((groupItemNumber) => (
            <option
              key={groupItemNumber}
              id={groupItemNumber}
              value={groupItemNumber}
            >
              {groupItemNumber}
            </option>
          ))}
        </select>
        <a
          href={`https://adminportal.${
            Environment.domainWithEnvironment
          }/External/Item%20Detail%20Page/ItemDetailPage?itemNumber=${encodeURIComponent(
            selectedItemNumber,
          )}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <input
            readOnly
            type="Button"
            value="Open Admin Page"
            style={{ marginLeft: "6px", width: "auto" }}
          />
        </a>
      </h3>
    </>
  );
};

export default InternalNotesVirtualGroupSelect;
